export class AxisMoveHandler2 {
    constructor(element, outputPrefix) {
        this.el = element;
        this.outputPrefix = outputPrefix;
        this.deadzone = 0.1;

        this.emitAxisMoveWithDeadzone =
            this.emitAxisMoveWithDeadzone.bind(this);
    }

    addEventListeners() {
        this.el.addEventListener("axismove", this.emitAxisMoveWithDeadzone);
    }

    removeEventListeners() {
        this.el.removeEventListener("axismove", this.emitAxisMoveWithDeadzone);
    }

    emitAxisMoveWithDeadzone(event) {
        const axis = event.detail.axis;

        if (
            Math.abs(axis[2]) >= this.deadzone ||
            Math.abs(axis[3]) >= this.deadzone
        ) {
            axis[3] = -axis[3];
            event.detail.axis[0] = axis[2];
            event.detail.axis[1] = axis[3];
            this.el.emit("axisMoveWithDeadzone", event.detail);
        }
    }
}
